/** Default accent (logo tile + primary CTA) when DB value is null/invalid. */
export const LINK_IN_BIO_DEFAULT_ACCENT_HEX = "#8a42ff";

/** Max length for public short description (tagline); aligned with Edge Function clamp. */
export const LINK_IN_BIO_TAGLINE_MAX_LENGTH = 500;

/**
 * @param {unknown} s
 * @returns {boolean}
 */
export function looksLikeHttpOrDataUrlString(s) {
  if (typeof s !== "string") {
    return false;
  }
  const v = s.trim().toLowerCase();
  return (
    v.startsWith("http://") ||
    v.startsWith("https://") ||
    v.startsWith("//") ||
    v.startsWith("data:") ||
    /^[a-z][a-z0-9+.-]*:\/\//i.test(v)
  );
}

/**
 * Normalize to #rrggbb or return fallback.
 * @param {unknown} input
 * @param {string} [fallback]
 * @returns {string}
 */
export function normalizeLinkInBioHexColor(
  input,
  fallback = LINK_IN_BIO_DEFAULT_ACCENT_HEX,
) {
  if (input == null || String(input).trim() === "") {
    return fallback;
  }
  const s = String(input).trim();
  const m = s.match(/^#?([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/);
  if (!m) {
    return fallback;
  }
  let hex = m[1];
  if (hex.length === 3) {
    hex = `${hex[0]}${hex[0]}${hex[1]}${hex[1]}${hex[2]}${hex[2]}`;
  }
  return `#${hex.toLowerCase()}`;
}

/**
 * @param {unknown} s
 * @param {number} max
 * @returns {string}
 */
export function clampLinkInBioTagline(s, max = LINK_IN_BIO_TAGLINE_MAX_LENGTH) {
  if (s == null) {
    return "";
  }
  const t = String(s);
  return t.length <= max ? t : t.slice(0, max);
}

/**
 * @param {string} hex — #rrggbb
 * @param {number} alpha — 0..1
 * @returns {string}
 */
export function hexToRgba(hex, alpha) {
  const n = hex.replace("#", "");
  if (n.length !== 6) {
    return `rgba(138, 66, 255, ${alpha})`;
  }
  const r = parseInt(n.slice(0, 2), 16);
  const g = parseInt(n.slice(2, 4), 16);
  const b = parseInt(n.slice(4, 6), 16);
  return `rgba(${r},${g},${b},${alpha})`;
}

/**
 * Pick the higher-contrast neutral foreground without modifying customer input.
 * @param {unknown} background
 * @returns {"#ffffff" | "#0f172a"}
 */
export function getReadableCustomerTextColor(background) {
  const hex = normalizeLinkInBioHexColor(background).slice(1);
  const channels = [0, 2, 4].map((offset) => {
    const channel = parseInt(hex.slice(offset, offset + 2), 16) / 255;
    return channel <= 0.04045
      ? channel / 12.92
      : ((channel + 0.055) / 1.055) ** 2.4;
  });
  const luminance =
    channels[0] * 0.2126 + channels[1] * 0.7152 + channels[2] * 0.0722;
  const whiteContrast = 1.05 / (luminance + 0.05);
  const inkLuminance = 0.0088;
  const inkContrast = (luminance + 0.05) / (inkLuminance + 0.05);

  return whiteContrast >= inkContrast ? "#ffffff" : "#0f172a";
}
